import { ReactNode } from 'react';

import RoundButtonIcon from '../RoundButtonIcon/RoundButtonIcon';

import { Flex, Grid } from '@theme-ui/components';
import type { ThemeUIStyleObject } from '@theme-ui/css';

type ButtonWithIcon = {
  icon: string;
  onClick?: () => void;
  sx?: ThemeUIStyleObject;
  className?: string;
};

export type MapButtonsProps = {
  bottomLeft?: ButtonWithIcon;
  renderBottomLeft?: ReactNode;
  bottomMiddle?: ButtonWithIcon;
  renderBottomMiddle?: ReactNode;
  bottomRight?: ButtonWithIcon;
  renderBottomRight?: ReactNode;
  sx?: ThemeUIStyleObject;
};

const MapButtons = ({
  bottomLeft,
  renderBottomLeft,
  bottomMiddle,
  renderBottomMiddle,
  bottomRight,
  renderBottomRight,
  sx,
}: MapButtonsProps) => {
  return (
    <Grid
      sx={{
        position: 'absolute',
        left: 7,
        bottom: [9, 8],
        ...sx,
      }}
      columns={3}
    >
      <Flex sx={{ justifyContent: 'left' }}>
        {bottomLeft && (
          <RoundButtonIcon
            {...bottomLeft}
            sx={{ ...bottomLeft.sx }}
            aria-label="bottom-left"
          />
        )}
        {renderBottomLeft}
      </Flex>

      <Flex sx={{ justifyContent: 'center' }}>
        {bottomMiddle && (
          <RoundButtonIcon
            {...bottomMiddle}
            sx={{ ...bottomMiddle.sx }}
            aria-label="bottom-middle"
          />
        )}
        {renderBottomMiddle}
      </Flex>

      <Flex sx={{ justifyContent: 'flex-end' }}>
        {bottomRight && (
          <RoundButtonIcon
            {...bottomRight}
            sx={{ ...bottomRight.sx }}
            aria-label="bottom-right"
          />
        )}
        {renderBottomRight}
      </Flex>
    </Grid>
  );
};

export default MapButtons;
